/* ── Infinite scroll for paginated listing pages ──
   Replaces numbered pagination with auto-loading on scroll for Shop
   Canvas, Custom Canvas, Custom Crystal, and the blog list. The numbered
   pagination markup (snippets/pagination.liquid) is kept in the DOM as a
   no-JS fallback and hidden via CSS — this script reads the same "next
   page" link that snippet already renders (`a.pagination__item--prev`)
   to know the next URL, both for the very first page (from the initial
   data-next-url attribute) and for every page fetched after that (parsed
   out of the fetched HTML), so no extra Liquid plumbing is needed beyond
   passing the first `paginate.next.url`.

   Usage:
   <infinite-scroll-grid data-container-selector="#product-grid" data-item-selector="li.grid__item" data-next-url="{{ paginate.next.url }}">
     <ul id="product-grid">...</ul>
     {% render 'pagination', paginate: paginate %}
   </infinite-scroll-grid>
*/
(function () {
  if (customElements.get('infinite-scroll-grid')) return;

  customElements.define('infinite-scroll-grid', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.containerSelector = this.getAttribute('data-container-selector');
      this.itemSelector = this.getAttribute('data-item-selector');
      this.container = this.querySelector(this.containerSelector);
      this.nextUrl = this.getAttribute('data-next-url') || '';
      this.loading = false;

      if (!this.container || !this.nextUrl) return;
      if (!('IntersectionObserver' in window)) return;

      this.sentinel = document.createElement('div');
      this.sentinel.setAttribute('aria-hidden', 'true');
      this.sentinel.className = 'infinite-scroll-sentinel';
      // Dawn's base.css hides genuinely empty block elements sitewide
      // (`div:empty { display: none; }`, meant for stray rich-text-editor
      // artifacts) — a real child keeps this sentinel from matching that
      // rule, since a display:none element can never be "intersecting".
      this.sentinel.appendChild(document.createElement('span'));
      this.appendChild(this.sentinel);

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '600px 0px'
      });
      this.observer.observe(this.sentinel);
    }

    onIntersect(entries) {
      var self = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !self.loading && self.nextUrl) {
          self.loadMore();
        }
      });
    }

    loadMore() {
      var self = this;
      this.loading = true;
      this.sentinel.classList.add('is-loading');

      fetch(this.nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newContainer = doc.querySelector(self.containerSelector);

          if (newContainer) {
            var items = newContainer.querySelectorAll(self.itemSelector);
            items.forEach(function (item) {
              self.container.appendChild(item);
            });
          }

          var nextLink = doc.querySelector('a.pagination__item--prev');
          self.nextUrl = nextLink ? nextLink.getAttribute('href') : '';
        })
        .catch(function (err) {
          console.warn('[infinite-scroll] failed to load more:', err);
          self.nextUrl = '';
        })
        .finally(function () {
          self.loading = false;
          self.sentinel.classList.remove('is-loading');
          if (!self.nextUrl && self.observer) {
            self.observer.disconnect();
          }
        });
    }
  });
})();
